import _ from 'lodash';
import template from './shopNav.html';

class NavController {
    /*@ngInject*/ 
    constructor($rootScope, $scope, $window, $location, $timeout, $q, $log, cartService, dataContext, constants, linklists, templateData, shopUserService) {
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.$location = $location;
        this.$timeout = $timeout;
        this.$log = $log;

        this.cartService = cartService;
        this.dataContext = dataContext;
        this.$q = $q;

        this.constants = constants;
        this.linklists = linklists;
        this.templateData = templateData;

        this.isActive = this.isActive.bind(this);
        this.shopUserService = shopUserService;

        $scope.$on('cartItemsChanged', (e, data) => {
            this.refresh();
        });
    }

    $onInit() {
        this.isLoading = true;

        //get user information then process nav
        this.shopUserService.get()
            .then((result) => {
                this.user = result;
                return this.refresh()
                    .finally(() => {
                        this.isLoading = false;
                    });
         });
    }

    refresh() {
        return this.$q.all([
            this.getCart(),
            this.getPaymentInfo()
        ]).then(() => {
            const navMenuItems = this.getMenuItems(this.templateData);
            this.navMenuItems = navMenuItems;
        });
    }

    isActive(itemUrl, options = {}) {
        let trimmedItemUrl = _.trimEnd(itemUrl, '/');
        let currentPath = _.trimEnd(this.$window.location.pathname, '/');

        return !options.isHome
            ? (!options.isTop || _.size(trimmedItemUrl) >= _.size(currentPath)) && _.startsWith(currentPath, trimmedItemUrl)
            : currentPath === trimmedItemUrl;
    }

    getMenuItems(templateData) {
        let linklists = templateData.linklists;
        let baseUrl = templateData.baseUrl;
        let collection = templateData.collection;

        let servicePlanInfo = this.user.ServicePlanInfo || {};
        let isWsfUser = (servicePlanInfo.AdcServicePlan === 'WSF');

        let items = [{
            name: 'Back to Home',
            href: isWsfUser ? this.constants.customerPortalHomeHref : this.constants.adcHomeHref,
            faIcon: 'fa-angle-left'
        }];

        let mainMenu = this.linklists.getLinks('main-menu');

        if (!_.isNil(mainMenu)) {
            _.forEach(mainMenu, (mainMenuLink) => {
                if (mainMenuLink.title === 'Contact Us') {
                    var item = {
                        name: 'Support',
                        href: 'https://www.myfrontpoint.com/web/system/support',
                        isActive: () => {
                            return mainMenuLink.active || this.isActive(mainMenuLink.url, {
                                isHome: baseUrl === 'https://www.myfrontpoint.com/web/system/support',
                                isTop: false,
                                collection: collection
                            });
                        }
                    };
                }
                else {
                    var item = {
                        name: mainMenuLink.title,
                        href: mainMenuLink.url,
                        isActive: () => {
                            return mainMenuLink.active || this.isActive(mainMenuLink.url, {
                                isHome: baseUrl === mainMenuLink.url,
                                isTop: false,
                                collection: collection
                            });
                        }
                    };
                }

                let handle = _.get(mainMenuLink, 'object.handle');
                if (!_.isNil(handle)) {
                    let match = _.find(linklists, (l) => {
                        return _.lowerCase(l.handle) === _.lowerCase(handle);
                    });

                    if (!_.isNil(match)) { // has sub menu
                        let sub = _.map(match.links, (subMenuLink) => {
                            return {
                                name: subMenuLink.title,
                                href: subMenuLink.url,
                                isActive: () => {
                                    return subMenuLink.active || this.isActive(subMenuLink.url, {
                                        isHome: false,
                                        isTop: false,
                                        collection: collection
                                    });
                                }
                            };
                        });

                        item.sub = sub;
                        item.isActive = () => {
                            return mainMenuLink.active ||
                                _.some(sub, (s) => { return s.isActive(); }) ||
                                this.isActive(mainMenuLink.url, {
                                    isHome: false,
                                    isTop: true,
                                    collection: collection
                                });
                        };
                    }
                }

                items.push(item);
            });
        }

        return _.concat(items, [{
            template: '<fp-nav-shopping-cart cart="cart" payment-info="paymentInfo"></fp-nav-shopping-cart>',
            scope: {
                cart: this.cart,
                paymentInfo: this.paymentInfo
            }
        }, {
            template: '<fp-nav-checkout cart="cart" on-checkout="onCheckout()"></fp-nav-checkout>',
            scope: {
                cart: this.cart,
                onCheckout: () => {
                    this.$window.location.href = this.templateData.baseUrl + 'cart/checkout';
                }
            }
        }]);
    }

    getLinkList(handle) {
        return _.find(this.templateData.linklists, (l) => {
            return l.handle === handle;
        });
    }

    getCart() {
        return this.cartService.getCart()
            .then((response) => {
                this.cart = response.data;
            });
    }

    getPaymentInfo() {
        return this.dataContext.payment.getPaymentInfo()
            .then(response => {
                this.paymentInfo = response.PaymentInfo;
            });
    }

    onLogout() {
        this.dataContext.user.logout()
            .finally(() => {
                this.shopUserService.reset();
                this.$window.location.href = this.constants.loginHref;
            });
    }
}

export default {
    template: template,
    bindings: {
    },
    controller: NavController
};